module.exports = __webpack_public_path__ + "static/DWI20_Reg_1700x1200_Mittelrhein-585d946970e0be2b337122714079ad5f.jpeg";